// Single source of truth for the personal-account governance limitation,
// shared by the security rule descriptions, employee insights, and the setup
// flow so the wording never drifts — and so lifting the limitation is a
// one-line change here.
export const PERSONAL_ACCOUNT_GOVERNANCE_NOTE =
  "Speakeasy does not currently provide enforced governance for personal accounts in Claude Cowork and Claude Code Desktop. User-installed plugins and telemetry can be removed or changed.";
